export default __webpack_public_path__ + "static/media/nikisha.cd113d45.jpeg";